module.exports = __webpack_public_path__ + "img/kk.44604a8f.svg";